/**
 * Settings a deployment supplies at RUN time.
 *
 * The same bundle is promoted from dev to qa, demo and prod, so nothing that
 * differs between them can be compiled in. Instead each environment's bucket
 * carries its own /config.js, written by the frontend deploy workflow:
 *
 *   window.__TP_CONFIG__ = { apiUrl: "https://travplace-api-dev…", mode: "dev" };
 *
 * index.html loads it with a plain, blocking <script> before the app's module,
 * so these values are already set when any module reads them and every export
 * that depends on them can stay a synchronous constant.
 *
 * Locally public/config.js sets an empty object and every value falls back to
 * the TP_WEB_* build variables, exactly as before.
 */
export interface RuntimeConfig {
  /** Origin of the Connect API and the glyph fonts. */
  apiUrl?: string;
  /** Prefix for the plain-REST calls. */
  apiBaseUrl?: string;
  /** Prefix for the assistant. */
  aiUrl?: string;
  /** "dev" shows the in-progress features; anything else hides them. */
  mode?: string;
}

declare global {
  interface Window {
    __TP_CONFIG__?: RuntimeConfig;
  }
}

export const runtimeConfig: RuntimeConfig =
  (typeof window !== 'undefined' && window.__TP_CONFIG__) || {};
